import { Caption, useStyles } from '@archipro-design/aria';
import * as S from './NoSearchResults.style';

interface NoSearchResultsProps {
    resultsType: string;
}

/** Tabs whose only way to narrow the list is the search field. */
const SEARCH_ONLY_TYPES = new Set(['articles', 'videos']);

export const NoSearchResults = ({ resultsType }: NoSearchResultsProps) => {
    const { css } = useStyles();

    // Articles and Videos narrow by search alone — neither tab carries a
    // filter sidebar or a Refine control, so naming filters sends the reader
    // hunting for something that isn't on the page.
    const changeText = SEARCH_ONLY_TYPES.has(resultsType)
        ? 'search term'
        : 'filters or search term';

    return (
        <div className={css(S.NoResults)}>
            <Caption variant="03-alt" weight="regular">
                {`Sorry, 0 ${resultsType} found.`}
            </Caption>

            <Caption variant="03-alt" weight="regular">
                {`Try changing the ${changeText}.`}
            </Caption>
        </div>
    );
};
